import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TokenService } from 'services/token/token.service';
import { EntryService } from 'services/entry/entry.service';
import { ROLE_CODES } from 'constants/role.constants';
import { PlatformBrandingService } from 'features/organization-settings/platform-branding/platform-branding.service';
import { map, switchMap, tap } from 'rxjs/operators';
import { DomainService } from 'services/domain/domain.service';
import { DEFAULT_PRODUCTION_DOMAIN_NAME } from '../../../global';
import { NEVER, of } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'cm-verify-email',
  template: '',
})
export class VerifyEmailComponent implements OnInit, OnDestroy {
  verificationToken = '';

  constructor(
    private tokenService: TokenService,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private entryService: EntryService,
    private platformBrandingService: PlatformBrandingService,
    private domainService: DomainService,
  ) {}

  ngOnInit() {
    this.activatedRouter.params
      .pipe(
        untilDestroyed(this),
        tap((params) => (this.verificationToken = params['token'])),
        switchMap(() => {
          if ([DEFAULT_PRODUCTION_DOMAIN_NAME, ''].includes(this.domainService.getDomainNameFromUrl())) {
            return this.platformBrandingService.getBrandingSettingsByVerificationToken(this.verificationToken).pipe(
              map((brandingSettings) => {
                this.platformBrandingService.initPlatformBrandingOrRedirect(brandingSettings);
                return brandingSettings.domainName;
              }),
              switchMap((domainName) => (!!domainName ? NEVER : of(null))),
            );
          }
          return of(null);
        }),
        switchMap(() => this.tokenService.getUserLoginEmail(this.verificationToken)),
      )
      .subscribe(
        (data) => this.handleToken(data),
        () => this.router.navigate(['/organization/']),
      );
  }

  ngOnDestroy() {}

  private handleToken(data) {
    if (!data.role) {
      this.entryService.setMessageType({ msg: 'profile_exists', email: 'john@doe.com' });
      this.router.navigate(['/entry/message']);

      return;
    }

    if (data.role === ROLE_CODES.PROFESSIONAL) {
      this.router.navigate(['/entry/first-login/professional'], {
        queryParams: {
          loginProvider: data.loginProvider,
        },
      });
      return;
    }

    this.router.navigate([`/entry/first-login/organization`], {
      queryParams: {
        loginProvider: data.loginProvider,
      },
    });
  }
}
